<template>
  <b-card class="card-congratulation-medal">
    <b-card-text class="font-small-3">
      {{ dataProfile.name }} mendapatkan<br/>nilai <b>{{ dataProfile.amres.kategori_skor_motivasi }} </b> untuk<br/> skor motivasi.
    </b-card-text>
    <h4 class="mb-75 mt-1">
      <b-link>Skor Motivasi : {{ dataProfile.amres.skor_motivasi }}</b-link>
    </h4>
    <h4 class="mb-75 mt-1">
      <b-link>Skor Resiliensi : {{ dataProfile.amres.skor_resiliensi }}</b-link>
    </h4>
    <!-- <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
    >
      Lihat Skor
    </b-button> -->
    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Medal Pic"
      width="50"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardText,
    // BLink,
    BImg,
    // BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    dataProfile: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
}
</script>
